import { connect } from 'react-redux';
import ProfileList from '../presentation/profile_page/ProfileList';
import { removeProfileValues, updateProfile } from '../../actions/ProfileAction';
import { getDocuments, setCurrentDocument, showErrorMessage } from '../../actions/DocumentAction';
import { changeTab } from '../../actions/TabAction'
import { VIEW_TAB } from '../../constants';
import { changeDocumentType } from '../../actions/TypesAction';

const mapStateToProps = (state, ownProps) => {
    let o = {};
    if (state.documents.rawlist != null)
        o = { documents: state.documents.rawlist };
    o.strings = state.i18.strings;
    return o;
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        changeDocumentType: docType => {
            dispatch(changeDocumentType(docType))
        },
        changeTab: (tabId, metadata, action) => {
            dispatch(changeTab(tabId, metadata, action))
        },
        remove: (...values) => {
            dispatch(removeProfileValues(values));
        },
        searchDocuments: (docType, attributes, success) => {
            dispatch(getDocuments(docType, attributes, success))
        },
        showDocument: async (metadata, version) => {
            const r = await dispatch(setCurrentDocument(metadata, version));
            if (r.error)
                dispatch(showErrorMessage(r.error));
            else
                dispatch(changeTab(VIEW_TAB, metadata));
        },
        showErrorMessage: (message) => {
            dispatch(showErrorMessage(message));
        },
        updateProfile: (profile, success) => {
            dispatch(updateProfile(profile, success));
        }
    }
}

const ProfileListView = connect(mapStateToProps, mapDispatchToProps)(ProfileList)

export default ProfileListView;